import { render, staticRenderFns } from "./EditCreditoUsuario.vue?vue&type=template&id=16351347&"
import script from "./EditCreditoUsuario.vue?vue&type=script&lang=js&"
export * from "./EditCreditoUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports